import React, { useState } from 'react'
import { useQuery } from 'react-query'

import Estimates from './Estimates'
import { sortToObject } from '../../../utils/sort'
import { ContainerProvider } from '../../containerContext'
import { FILTER_DATE_RANGE } from '../../../core/constants/app'
import { useApi, useLoading } from '../../../hooks'

const queryOrigin = {
	query: {
		skip: 0,
		limit: 100,
		// Free text, kept outside filter so the mobile filter reset leaves it alone
		search: '',
		filter: {
			dateRange: FILTER_DATE_RANGE.ALLTIME,
			vendor: 'all',
			approved: 'all',
			status: 'all',
		},
	},
	sorted: {
		sortBy: 'dateCreated',
		sortDirection: 'desc',
	},
}

const Index = () => {
	const [state, setState] = useState({ ...queryOrigin })
	const { estimateService } = useApi()
	const {
		isLoading,
		isFetching,
		data = [],
	} = useQuery(
		['estimates', state.query, state.sorted],
		() => {
			const { filter, search, ...otherQuery } = state.query
			const params = {
				...otherQuery,
				sort: { ...sortToObject(state.sorted) },
				filter: {},
			}

			const { startDate, endDate, vendor, approved, status } = filter
			if (startDate && endDate) params.filter = { ...params.filter, startDate, endDate}
			if (vendor !== 'all') params.filter.company = vendor
			if (approved !== 'all') params.filter.approved = approved
			if (status !== 'all') params.filter.status = status
			// The API switches to its Atlas search path when text is present
			if (search && search.trim()) params.text = search.trim()

			return estimateService.many(params)
		},
		{
			refetchOnWindowFocus: false,
		},
	)

	// Same cue as the admin portal: the MTRX spinner over a dimmed screen while
	// results (first page, filters, search) are being fetched.
	useLoading(isFetching)

	return (
		<ContainerProvider
			state={state}
			setState={setState}
			data={data.estimates || []}
			stateOrigin={queryOrigin}
			isLoading={isLoading}
		>
			<Estimates />
		</ContainerProvider>
	)
}

export default Index
